<ng-template #modal let-hide="close">
  <div class="modal-header">
    <h4 i18n class="modal-title">My settings</h4>
    <my-global-icon iconName="cross" aria-label="Close" role="button" (click)="hide()"></my-global-icon>
  </div>

  <div class="modal-body">
    <div i18n class="mb-4 font-italic">These settings apply only to your session on this instance.</div>

    <h6 i18n class="mb-4">Display settings</h6>

    <my-user-video-settings
      *ngIf="!isUserLoggedIn()"
      [user]="user" [userInformationLoaded]="userInformationLoaded" [reactiveUpdate]="true" [notifyOnUpdate]="true"
    >

      <ng-container ngProjectAs="inner-title">
        <h6 i18n class="mb-4 mt-4">Video settings</h6>
      </ng-container>
    </my-user-video-settings>

    <h6 i18n class="mb-4 mt-4">Interface settings</h6>

    <my-user-interface-settings
      *ngIf="!isUserLoggedIn()"
      [user]="user" [userInformationLoaded]="userInformationLoaded" [reactiveUpdate]="true" [notifyOnUpdate]="true"
    ></my-user-interface-settings>
  </div>
</ng-template>
